export enum SideMenuSize {
  None = '',
  Small = 'small',
  Regular = 'regular',
}
